import React, {PureComponent} from "react";
import PropTypes from 'prop-types';
import OrderFormLandingPage from "./OrderFormLandingPage";
import OrderFormFilesPage from "./OrderFormFilesPage";
import OrderFormAuthPage from "./OrderFormAuthPage";
import {connect} from "react-redux";
import {PAGE_AUTH, PAGE_FILES, PAGE_LANDING} from "../../../constants/PageConstant";
import {openPage} from "../../../actions/PageActions";

const pageRoutes = {
    [PAGE_LANDING]: {previous: undefined, next: PAGE_FILES},
    [PAGE_FILES]: {previous: PAGE_LANDING, next: PAGE_AUTH},
    [PAGE_AUTH]: {previous: PAGE_FILES, next: undefined},
}

class OrderForm extends PureComponent {

    nextPage = () => {
        const {page, openPage} = this.props;

        const next = pageRoutes[page].next;

        if (next) {
            openPage(next);
        }
    };

    previousPage = () => {
        const {page, openPage} = this.props;
        const previous = pageRoutes[page].previous;

        if (previous) {
            openPage(previous);
        }
    };

    render() {
        const { onSubmit, initialValues, page } = this.props;

        return (
            <div>
                {page === PAGE_LANDING && (
                    <OrderFormLandingPage
                        onSubmit={this.nextPage}
                        initialValues={initialValues}
                    />
                )}
                {page === PAGE_FILES && (
                    <OrderFormFilesPage
                        previousPage={this.previousPage}
                        onSubmit={this.nextPage}
                    />
                )}
                {page === PAGE_AUTH && (
                    <OrderFormAuthPage
                        previousPage={this.previousPage}
                        onSubmit={onSubmit}
                    />
                )}
            </div>
        )
    }
}

OrderForm.propTypes = {
    onSubmit: PropTypes.func.isRequired
};

export default connect(
    state => ({
        page: state.page.page,
    }),
    dispatch => ({
        openPage: page => dispatch(openPage(page)),
    })
)(OrderForm);